import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasBenalmadena() {
  return (
    <CityPagePersianas
      name="Benalmádena"
      slug="benalmadena"
      cp="29630, 29631, 29639"
      poblacion={78787}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5988}
      lng={-4.5160}
      zonas={[
        "Benalmádena Pueblo",
        "Benalmádena Costa",
        "Arroyo de la Miel",
        "Torremuelle",
        "Torrequebrada",
      ]}
      landmarks={[
        "Puerto Marina",
        "Tivoli World",
        "Stupa de Iluminación",
        "Castillo de Bil-Bil",
        "Teleférico",
      ]}
      municipiosLimitrofes={[
        "Torremolinos",
        "Mijas",
        "Alhaurín de la Torre",
      ]}
      festivalLocal="Fiestas de la Virgen del Carmen, 16 de julio"
      contextoTipologico="Pueblo blanco tradicional con casas históricas en el Pueblo, urbanizaciones modernas en la Costa, comunidades de vecinos extensas en Arroyo de la Miel."
      isCoreZone={true}
    />
  );
}